import { createRouter, createWebHistory } from 'vue-router'
import { isSupabaseConfigured } from '@/lib/supabase'
import { useAuthStore } from '@/stores/auth'

export const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/setup',
      name: 'setup',
      component: () => import('@/views/SetupView.vue'),
      meta: { public: true },
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/LoginView.vue'),
      meta: { public: true },
    },
    {
      path: '/',
      component: () => import('@/layouts/AppShell.vue'),
      children: [
        { path: '', name: 'dashboard', component: () => import('@/views/DashboardView.vue') },
        {
          path: 'analytics',
          name: 'analytics',
          component: () => import('@/views/AnalyticsView.vue'),
        },
        { path: 'bots', name: 'bots', component: () => import('@/views/BotsView.vue') },
        { path: 'users', name: 'users', component: () => import('@/views/UsersView.vue') },
        { path: 'journal', name: 'journal', component: () => import('@/views/JournalView.vue') },
        {
          path: 'templates',
          name: 'templates',
          component: () => import('@/views/TemplatesView.vue'),
        },
        { path: 'settings', name: 'settings', component: () => import('@/views/SettingsView.vue') },
        { path: 'audit', name: 'audit', component: () => import('@/views/AuditView.vue') },
      ],
    },
    { path: '/:pathMatch(.*)*', redirect: '/' },
  ],
})

router.beforeEach(async (to) => {
  // Без .env любой запрос к Supabase упадёт — сразу объясняем, что заполнить.
  if (!isSupabaseConfigured) {
    return to.name === 'setup' ? true : { name: 'setup' }
  }
  if (to.name === 'setup') {
    return { name: 'dashboard' }
  }

  const auth = useAuthStore()
  try {
    await auth.init()
  } catch (initError) {
    // Подъём сессии ходит в сеть. Если он упал, гард обязан довести навигацию
    // до конца: иначе vue-router просто отменит переход и панель застынет
    // на пустом экране, ничего не объяснив.
    console.warn('Не удалось поднять сессию:', initError)
    return to.name === 'login' ? true : { name: 'login', query: { failed: '1' } }
  }

  if (!to.meta.public && !auth.session) {
    return { name: 'login', query: { redirect: to.fullPath } }
  }
  // Сессия есть — но этого мало: в панель пускаем только тех, кто есть
  // в таблице admins. Иначе посторонний увидит пустые таблицы вместо отказа.
  if (!to.meta.public) {
    const allowed = await auth.checkAdmin()
    if (!allowed) {
      // Выход тоже ходит в сеть, и его сбой не повод срывать переход: увести
      // на вход важнее, чем закрыть сессию до конца.
      await auth.signOut().catch((signOutError: unknown) => {
        console.warn('Не удалось выйти из аккаунта:', signOutError)
      })
      return { name: 'login', query: { denied: '1' } }
    }
  }
  // Условие про права защищает от петли: если signOut не довёл сессию до конца,
  // отказанный пользователь остаётся на входе, а не мечется между ним и панелью.
  if (to.name === 'login' && auth.session && auth.isAdmin !== false) {
    return { name: 'dashboard' }
  }
  return true
})
